import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Check, X } from "lucide-react";

const STEPS = [
  { title: "Welcome to NEXFIN TRADE", body: "A quick 6-step tour from login to live P&L. You can replay it anytime using the ? button in the top bar.", tab: null },
  { title: "1 · Connect your broker", body: "Open Broker & Data and log in to Alice Blue to switch from simulated demo data to real-time quotes and charts. Until then, all prices are simulated for practice.", tab: "broker" },
  { title: "2 · Choose a strategy", body: "On Strategies, pick NEXFIN ORB (or EMA Crossover / VWAP Trend), tune the parameters, or load a saved preset in one click.", tab: "strategies" },
  { title: "3 · Deploy — one symbol or the whole Nifty 50", body: "Start a single paper/live run, or switch to Multi-symbol and deploy across many stocks at once. Use the sector filters to build a basket fast.", tab: "strategies" },
  { title: "4 · Watch the Live Trade Panel", body: "The live chart draws the opening-range high/low, stop-loss & target lines, and buy/sell arrow markers as trades trigger.", tab: "live" },
  { title: "5 · Backtest & optimize", body: "Validate on history: run a Backtest, Compare strategies or parameters, or Optimize to grid-search the best-performing settings.", tab: "orbtest" },
  { title: "6 · Review your P&L", body: "Reports shows daily & monthly P&L with CSV and PDF export. That completes the full loop — happy trading!", tab: "reports" },
];

export default function GuidedTour({ onNavigate, onClose }) {
  const [i, setI] = useState(0);
  const step = STEPS[i];

  useEffect(() => { if (step.tab) onNavigate?.(step.tab); }, [i]); // eslint-disable-line

  const finish = () => { localStorage.setItem("nq_tour_done", "1"); onClose?.(); };

  return (
    <div className="fixed bottom-4 right-4 z-[60] w-[360px] max-w-[92vw] panel p-5 rise shadow-2xl border border-[#22A34A]/40" data-testid="guided-tour">
      <div className="flex items-start gap-2">
        <h3 className="font-display text-base font-bold text-white leading-tight">{step.title}</h3>
        <button data-testid="tour-skip" onClick={finish} className="ml-auto text-slate-500 hover:text-white" title="Close tour"><X className="w-4 h-4" /></button>
      </div>
      <p className="text-xs text-slate-300 leading-relaxed mt-2">{step.body}</p>
      <div className="flex items-center gap-1.5 mt-4" data-testid="tour-progress">
        {STEPS.map((_, idx) => <span key={idx} className={`h-1.5 rounded-full transition-all ${idx === i ? "w-5 bg-[#22A34A]" : "w-1.5 bg-[#163056]"}`} />)}
      </div>
      <div className="flex items-center gap-2 mt-4">
        {i > 0 && <button data-testid="tour-back" onClick={() => setI(i - 1)} className="btn-ghost h-8 text-xs"><ArrowLeft className="w-3.5 h-3.5" /> Back</button>}
        <span className="text-[10px] font-mono text-slate-500 ml-auto">{i + 1} / {STEPS.length}</span>
        {i < STEPS.length - 1
          ? <button data-testid="tour-next" onClick={() => setI(i + 1)} className="btn-primary h-8 text-xs">Next <ArrowRight className="w-3.5 h-3.5" /></button>
          : <button data-testid="tour-done" onClick={finish} className="btn-primary h-8 text-xs"><Check className="w-3.5 h-3.5" /> Got it</button>}
      </div>
    </div>
  );
}
